/* eslint-disable camelcase */
import translation_DE from './locales/de.yaml';
import translation_EN from './locales/en.yaml';
import translation_ES_US from './locales/es-us.yaml';
import translation_ES from './locales/es.yaml';
import translation_FR_CA from './locales/fr-ca.yaml';
import translation_FR from './locales/fr.yaml';
import translation_IT from './locales/it.yaml';
import translation_NL from './locales/nl.yaml';
import translation_PT from './locales/pt.yaml';
import { initI18n } from '@rpi/i18n';

export const resources = {
  de: {
    translation: translation_DE,
  },
  en: {
    translation: translation_EN,
  },
  es: {
    translation: translation_ES,
  },
  'es-us': {
    translation: translation_ES_US,
  },
  fr: {
    translation: translation_FR,
  },
  'fr-ca': {
    translation: translation_FR_CA,
  },
  it: {
    translation: translation_IT,
  },
  nl: {
    translation: translation_NL,
  },
  pt: {
    translation: translation_PT,
  },
} as const;

initI18n(resources);
